"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessage = getErrorMessage;
function getErrorMessage(error, defaultMessage = 'Unknown error') {
    if (error != null && typeof error === 'object') {
        if ('message' in error && typeof error.message === 'string') {
            return error.message;
        }
        else {
            return defaultMessage;
        }
    }
    else if (typeof error === 'string') {
        return error;
    }
    return defaultMessage;
}
